import { createFeatureSelector } from '@ngrx/store';
import * as fromSurveyTasks from './survey-tasks.reducer';

export const selectSurveyTaskState =
  createFeatureSelector<fromSurveyTasks.SurveyTaskState>(
    fromSurveyTasks.surveyTasksFeatureKey,
  );
